// Shared feed-data "warm args" — the single source of truth for the
// per-surface params the listing feeds expect on their first mount.
//
// Prefetch payloads MUST match each feed's first-mount filter/sort args for the
// warmed cache entry to hit. The category pill rail (`category-nav.tsx`)
// warms the FILTERED feeds on hover using these args — additive DATA prefetch
// distinct from the route (RSC) prefetch that the nav `<Link>`s now own via the
// intent-armed `useIntentPrefetchArm`. The args live here once so the
// byte-match payload never drifts.

import {
  getMarketsFeedSortOrder,
  MARKETS_FEED_DEFAULT_SORT,
} from '@/components/markets/markets-feed-sorts';
import {
  getWinnersFeedSortOrder,
  WINNERS_FEED_DEFAULT_SORT,
} from '@/components/markets/winners/winners-feed-sorts';
import { MARKETS_LIST_OPEN_STATUS } from '@/lib/market/listing-status';
import { LAUNCHPAD_FEED_FIELDS } from '@/lib/sdk/projections/launchpad-feed';

const PROPOSALS_DEFAULT_SORT = 'totalFunded' as const;

/** JSON-safe shape accepted by the SDK prefetch hooks. */
export type WarmArgs = Record<string, string | readonly string[]>;

/** Base args (no category) for warming each surface's feed cache. */
export function warmArgsForBase(base: string): WarmArgs {
  switch (base) {
    case '/winners':
      return {
        sortBy: WINNERS_FEED_DEFAULT_SORT,
        sortOrder: getWinnersFeedSortOrder(WINNERS_FEED_DEFAULT_SORT),
      };
    case '/proposals':
      return {
        fields: [...LAUNCHPAD_FEED_FIELDS],
        sortBy: PROPOSALS_DEFAULT_SORT,
        sortOrder: 'desc',
        status: 'all',
        excludeStatus: 'live',
      };
    default:
      return {
        sortBy: MARKETS_FEED_DEFAULT_SORT,
        sortOrder: getMarketsFeedSortOrder(MARKETS_FEED_DEFAULT_SORT),
        status: MARKETS_LIST_OPEN_STATUS,
      };
  }
}
